import { GetterTree } from 'vuex'
import HistoryState from '../types/HistoryState'
import RootState from '@vue-storefront/core/types/RootState'

const getters: GetterTree<HistoryState, RootState> = {
  getRoute: state => state.route
}

export default getters
